<template>
  <div 
    v-if="!showSpinner"
    class="sm-add-services"
  >
    <h4 class="sm-txt-center">Your account is almost ready to go</h4>
    <p class="sm-lead sm-txt-center">Select your SpherePhone plan</p>
    <div class="sm-add-services-sec">
      <div class="sm-add-services__block">
        <div class="sm-add-services__block-head">
          <p class="sm-h4 sm-add-services__block-head-title">SpherePhone Virtual Phone</p>
        </div>

        <div class="sm-add-services__block-main">
          <p class="sm-reg sm-add-services__block-main-desc">Just enter your desired U.S. or International area code number and we'll do the rest. Automatically we'll forward calls to your mobile or landline number.</p>

          <p class="sm-reg sm-add-services__block-main-stats">
            <span 
              v-if="userPlan.phone_price"
              class="sm-reg"
            >
              <strong class="sm-sys large">{{formatPrice(userPlan.phone_price, 0)}}&nbsp;</strong>
              <span class="sm-small">/number</span>
            </span>
            <span 
              v-if="userPlan.toll_free_phone_price"
              class="sm-reg"
            >
              <strong class="sm-sys large">{{formatPrice(userPlan.toll_free_phone_price, 0)}}&nbsp;</strong>
              <span class="sm-small">/toll free number</span>
            </span>
          </p>
        </div>
        <div class="sm-add-services__block-footer">
          <div class="sm-add-services__block-footer-btn">
            <btn-block 
              :type="'small'" 
              :text="'Select Phone Number'" 
              @click="$router.push('account?tab=phone')"
            />
          </div>
        </div>
      </div>
    </div>

    <p 
      v-if="!userAccount.live_receptionist_plan_id"
      class="sm-lead sm-txt-center spaced"
    >or subscribe to Live Receptionist plan</p>
    <ul 
      v-if="!userAccount.live_receptionist_plan_id"
      class="sm-add-services-sec"
    >
      <li
        v-for="item in receptionistList"
        :key="item.id"
      >
        <div class="sm-add-services__block">
          <div class="sm-add-services__block-head">
            <p class="sm-h4 sm-add-services__block-head-title">{{ item.name }}</p>
          </div>

          <div class="sm-add-services__block-main">
            <p class="sm-reg sm-add-services__block-main-desc">{{ item.description }}</p>

            <p class="sm-reg sm-add-services__block-main-stats">
              <span class="sm-reg">
                <strong class="sm-sys">{{ item.minutes }}</strong>
                live answering calls
              </span>
              <!-- <span class="sm-reg">
                <strong class="sm-sys">{{ item.average_calls }}</strong>
                average calls per month
              </span> -->
            </p>
          </div>
          <div class="sm-add-services__block-footer">
            <div class="sm-add-services__block-footer-price">
              <strong>{{ formatPrice(item.price, 0) }}</strong>
              <span class="sm-small">/month</span>
            </div>

            <div class="sm-add-services__block-footer-btn">
              <btn-block 
                :type="'small'" 
                :text="'Subscribe'" 
                @click="showPopup(item)"
              />
            </div>
          </div>
        </div>
      </li>
    </ul>

    <popup-block
      v-if="popup.isOpen"
      :size="popup.size"
      :open="popup.isOpen"
      class="sm-add-services__popup"
      @close="closeConfirm"
    >
      <template slot="popupContent">
        <confirm-block
          :text="`Your account will be charged an amount of ${formatPrice(popup.item.price, 0)} immediately.`"
          @confirm="subscribe(popup.item)"
          @cancel="popup.isOpen = false"
        />
      </template>
    </popup-block>
  </div>
  <sm-spinner 
    v-else 
    :show="showSpinner"
  />
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import {FormatPrice} from '@/utils/general-data';
import Spinner from '@/components/Spinner';
import Popup from '@/components/Popup';
import Confirm from '@/components/Confirm';

export default {
  name: 'additional-services',
  components: {
    'sm-spinner': Spinner,
    'popup-block': Popup,
    'confirm-block': Confirm
  },
  data() {
    return {
      receptionistList: [],
      showSpinner: false,
      popup: {
        isOpen: false,

      }
    };
  },
  created() {
    this.showSpinner = true;
    this.getReceptionistList()
      .then(res => {
        this.receptionistList = [...res.plans];
        this.showSpinner = false;
      });
  },
  computed: {
    ...mapGetters({
      userPlan: 'account/userPlan',
      userAccount: 'account/userAccount',
    })
  },
  methods: {
    ...mapActions({
      getReceptionistList: 'account/getReceptionistList',
      subToReceptionist: 'account/subToReceptionist',
    }),
    formatPrice: FormatPrice,
    subscribe(item) {
      this.subToReceptionist(item.id)
        .then(() => {
        this.closeConfirm();
        this.$emit('subscribe', item.name);
      });
    },
    showPopup(item) {
      this.popup.item = item;
      this.popup.isOpen = true;
    },
    closeConfirm() {
      setTimeout(() => this.popup.isOpen = false, 1);
    }
  }
}
</script>

<style lang="scss">
  @use '@/assets/scss/general/mixins.scss' as *;
  @use '@/assets/scss/framework/scss-variables.scss' as *;
  @use '@/assets/scss/page-elements/_additional-services.scss';
</style>